import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { MemberInfoTypes } from '../Types';

const machine = Machines.onMemberInfo.machine;

export const getMemberInfo = (): Promise<MemberInfoTypes.IMemberInfoServiceResponse> => {
  return callServiceMachine(machine);
};

export default { getMemberInfo };
